var svg = "<svg class=\"external-link-svg\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\">\n  <path d=\"M1.5 7.27A1.5 1.5 0 000 8.77v29.74A1.5 1.5 0 001.5 40h29.73a1.5 1.5 0 001.5-1.49V19.92a1.5 1.5 0 10-3 0V37H3V10.26h17.08a1.5 1.5 0 100-3z\" fill=\"currentColor\"/>\n  <path d=\"M24.47 0a1.41 1.41 0 000 2.81h10.74l-18.8 18.8a1.39 1.39 0 000 2 1.43 1.43 0 002 0l18.8-18.8v10.72a1.41 1.41 0 102.81 0V1.4A1.4 1.4 0 0038.6 0z\" fill=\"currentColor\"/>\n</svg>";
var span = "<span class=\"sr-only\">(opens in a new tab)</span>";
DomObserver.observe('[target="_blank"]', function (links) {
  links.forEach(function (link) {
    link.rel = "noopener";
    link.insertAdjacentHTML('beforeend', span);

    // If the link already has an icon, skip it
    if (link.querySelector('svg')) return;
    if (link.querySelector('img')) return;

    // Otherwise, add the icon
    link.insertAdjacentHTML('beforeend', svg);
  });
});